import styled from 'styled-components';
import { getThemeProp } from 'theme';

export const SResult = styled.div`
  background: ${getThemeProp('colors.white')};
  border-radius: 5px;
  box-shadow: 0 3px 20px 0 rgba(116, 116, 116, 0.5);
  line-height: 26px;
  max-height: 60vh;
  min-height: auto;
  overflow: auto;
  position: absolute;
  text-align: left;
  top: 31px;
  width: 570px;
  z-index: 999;
`;

export const SNoResults = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 96px;
  font-size: 15px;
  font-weight: 300;
`;
